import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaXTwitter, FaYoutube } from 'react-icons/fa6';

const ConnectCard2 = ({ data, onArticleClick}) => {
      const {
    name,
    title,
    image,
    itemcategory_name,
    meta_description,
    description,
    facebook_url,
    youtube_url,
    instagram_url,
    linkedin_url,
    twitter_url,
    post_url,
  } = data || {};

  const imgSrc = image || "/placeholder.png";
  return (
    <article
      className="
        group relative
        bg-white rounded-2xl
    border border-gray-200 
        shadow-md
        transition-all duration-300 ease-out
        hover:-translate-y-2 hover:shadow-2xl

        flex flex-col h-full
      "
    >
      {/* Subtle glow */}
      <div
        className="
          pointer-events-none absolute inset-0 rounded-2xl
          opacity-0 group-hover:opacity-100
          transition duration-300
          bg-gradient-to-br from-orange-300/20 via-yellow-200/20 to-transparent
        "
      />

      {/* Image Area */}
      <div className="relative flex justify-center py-7 bg-gradient-to-br from-amber-100 via-orange-200 to-yellow-100 rounded-t-2xl">
        <span className="absolute top-0 left-0 text-[11px] font-medium bg-orange-600 text-white px-2 py-1 rounded-e-full">
          {itemcategory_name || "Featured"}
        </span>

        <img
          src={imgSrc}
          alt={name}
          className="
            w-28 h-28 md:w-32 md:h-32
            rounded-full object-cover
            border-4 border-white
            shadow-md
            transition-transform duration-300
            group-hover:scale-105
          "
        />
      </div>

      {/* Content */}
      <div className="relative p-2 text-center flex flex-col flex-grow">
        <h3 className="text-[16px] font-semibold text-[#9d2e43]  line-clamp-1">
          {name}
        </h3>

        <p className="text-sm  font-medium text-orange-600 mt-1">
          {title || "Spiritual & Religious Leader"}
        </p>

        <p
          className="mt-3 text-[14px]  leading-[1.6]  !text-[#6a6868] line-clamp-3 h-[64px]"
          dangerouslySetInnerHTML={{ __html:  description || meta_description }}
        />

        {/* ✅ Bottom-fixed area */}
<div className="mt-auto pt-4">
  {/* Social Icons (moved ABOVE buttons) */}
  {(facebook_url || youtube_url || twitter_url || instagram_url || linkedin_url) && (
    <>
      <div className="flex justify-center gap-2">
        {facebook_url && (
          <SocialIconSmall href={facebook_url}>
            <FaFacebookF />
          </SocialIconSmall>
        )}
        {youtube_url && (
          <SocialIconSmall href={youtube_url}>
            <FaYoutube />
          </SocialIconSmall>
        )}
        {twitter_url && (
          <SocialIconSmall href={twitter_url}>
            <FaXTwitter />
          </SocialIconSmall>
        )}
        {instagram_url && (
          <SocialIconSmall href={instagram_url}>
            <FaInstagram />
          </SocialIconSmall>
        )}
        {linkedin_url && (
          <SocialIconSmall href={linkedin_url}>
            <FaLinkedinIn />
          </SocialIconSmall>
        )}
      </div>

      {/* Divider */}
      <div className="my-3 flex items-center justify-center">
        <span className="h-[1px] w-12 bg-gradient-to-r from-transparent via-orange-400/80 to-transparent" />
      </div>
    </>
  )}

  {/* Action Buttons */}
  <div className="flex justify-between gap-3">
     <button
            onClick={() => onArticleClick?.(data)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-50 text-orange-600 font-medium text-xs xl:text-sm hover:bg-orange-100 transition-colors w-auto"
          >
            Read More <span className="text-sm">→</span>
          </button>

          {data?.post_url && (
            <a
              href={data.post_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 font-medium text-xs xl:text-sm hover:bg-gray-200 transition-colors w-auto"
            >
              Visit on Site <span className="text-sm">↗</span>
            </a>
          )}
  </div>
</div>
      </div>
    </article>
  );
}

function SocialIconSmall({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="
        w-8 h-8 flex items-center justify-center
        rounded-full border border-gray-200
        bg-white text-gray-600
        shadow-sm
        hover:bg-orange-500 hover:text-white hover:border-orange-500
        transition-all duration-300
      "
    >
      <span className="text-[14px] leading-none">{children}</span>
    </a>
  );
}

export default ConnectCard2